import React from 'react';
import { BiLoaderAlt } from 'react-icons/bi';

const ButtonAuth = ({ label, className, onClick, isDisabled, isSubmitting, type, submitRef }) => {
  return (
    <button
      className={`${className} bg-black text-white py-3 w-full uppercase h-[45px] focus-visible:outline-none ${
        isDisabled ? 'pointer-events-none opacity-50' : 'pointer-events-auto'
      }`}
      type={type}
      onClick={onClick}
      ref={submitRef}>
      {isSubmitting ? <BiLoaderAlt className=" m-auto animate-spin" /> : label}
    </button>
  );
};

export default ButtonAuth;
